// This is our loading with base styling

import { ButtonHTMLAttributes, FunctionComponent } from 'react';
import { cn } from '../../utilities/cn';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import { motion } from 'framer-motion';
import { HiCheck, HiXMark } from 'react-icons/hi2';
import { Tooltip } from '@mui/material';

interface LoadingButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading: boolean;
  // When true, applies a small shake animation via Framer Motion
  animate?: boolean;
  // Visual states controlled by parent
  isSuccess?: boolean;
  isError?: boolean;
  tooltip?: {
    title?: string;
    placement?: 'top' | 'bottom' | 'left' | 'right';
  }
}

const LoadingButton: FunctionComponent<LoadingButtonProps> = ({
  isLoading,
  isSuccess = false,
  isError = false,
  children,
  animate = false,
  tooltip,
  ...props
}) => {
  const shake = animate ? { x: [0, -2, 2, -1, 1, 0] } : undefined;
  const bgClass = isSuccess
    ? 'bg-green-600 hover:bg-green-700'
    : isError
      ? 'bg-red-500 hover:bg-red-700'
      : 'bg-mainblue hover:bg-mainblue/90';
  return (

    <Tooltip title={tooltip?.title} placement={tooltip?.placement || 'top'}>
      <motion.button
        {...(props as any)}
        disabled={props.disabled || isLoading || isSuccess}
        className={cn(
          'group relative cursor-pointer rounded px-5 py-2 text-sm font-medium text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-opacity-80',
          bgClass,
          props.className,
        )}
        animate={shake as any}
        transition={animate ? { duration: 0.4, ease: 'easeInOut' } : undefined}
      >
        {(isLoading || isSuccess || isError) && (
          <span className="absolute inset-0 flex items-center justify-center">
            {isLoading ? (
              <RotateLeftIcon className="animate-spin text-white" />
            ) : isSuccess ? (
              <HiCheck className="h-4 w-4 text-white" />
            ) : (
              <>
                <HiXMark className="h-4 w-4 text-white" />
                <span className="text-white">Failed - try again</span>
              </>
            )}
          </span>
        )}
        <span className={isLoading || isSuccess || isError ? 'invisible' : ''}>
          {children}
        </span>
      </motion.button>
    </Tooltip>
  );
};

export default LoadingButton;
